
import Vue from "vue";
import YmapPlugin, {
  loadYmap
} from "vue-yandex-maps";

const settings = {
  apiKey: process.env.yandexApiKey,
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
}
Vue.use(YmapPlugin, settings);

export default {
  name: "Map",

  data: function () {
    return {
      cities: [],

      yandexMapCoords: [57.649562, 82.957988],
      yandexMap: null
    }
  },

  props: {
    points: {
      type: Array,
      default: () => {
        return []
      }
    },

    useApiAddress: {
      type: Boolean,
      default: false
    }
  },

  mounted: async function () {
    await this.initYandexMap();
  },
  destroyed: async function () {
  },

  methods: {
    initYandexMap: async function () {
      if (!this.$refs["yandex-map"]) {
        return
      }

      await loadYmap({...settings, debug: true});
      this.yandexMap = new ymaps.Map(this.$refs["yandex-map"], {
        center: this.yandexMapCoords,
        zoom: 4,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch']
      });

      await this.setCitiesPoints();
    },
    destroyedYandexMap: function () {
    },

    setCitiesPoints: async function () {

      // Получение подробной информации
      let cities = [];
      await Promise.all(this.points.map(async (point) => {
        let coordinates = [point?.city?.latitude, point?.city?.longitude];
        if (this.useApiAddress) {
          const response = await this._getInformationCity([point?.country, point?.city].join(" "));
          coordinates = response?.coordinates;
        }

        if (point?.city?.latitude && point?.city?.longitude) {
          cities.push({
            ...point,
            coordinates
          })
        }
        if (this.useApiAddress) {
          cities.push({
            ...point,
            coordinates
          })
        }
      }));
      if (cities.length <= 0) {
        return
      }

      this.cities = cities;

      // Построение точек на карте
      const yandexMap = this.yandexMap;
      const cluster = this._generateCluster();
      cities.map((city) => {
        let label = city.city_name;
        if (this.useApiAddress) {
          label = [city.country, city.city].filter((t) => !!t).join(" ")
        }

        const placemark = this._generatePlacemark({
          coordinates: city.coordinates,
          label: label
        });
        cluster.add(placemark);
      });
      yandexMap.geoObjects.add(cluster);

      let optionsBounds = {};
      if (this.useApiAddress) {
        optionsBounds =  {
          checkZoomRange: true
        }
      }

      yandexMap.setBounds(cluster.getBounds(), optionsBounds);
    },
    _getInformationCity: async function (city) {
      return await ymaps.geocode(city).then((res) => {
        const coordinates = res.geoObjects.get(0).geometry.getCoordinates();

        return {
          coordinates
        }
      }).catch(() => {
        return {
          coordinates: [],
        }
      });
    },
    _generateCluster: function () {
      const clusterIconLayout = ymaps.templateLayoutFactory.createClass('' +
          '<div class="route-map-with-points-map-pin-cluster">' +
          '<span>{{ properties.geoObjects.length }}</span>' +
          '</div>')

      return new ymaps.Clusterer({
        clusterDisableClickZoom: false,
        clusterNumbers: [50],
        clusterIconLayout: clusterIconLayout,
        clusterIconShape: {
          type: 'Rectangle',
          coordinates: [[0, 0], [46, 46]]
        }
      })
    },
    _generatePlacemark: function (point) {
      const iconContentLayout = ymaps.templateLayoutFactory.createClass(
          `<div class="route-map-with-points-map-map-poins"/>`
      );

      return new ymaps.Placemark(point.coordinates, {
        hintContent: point.city_name,
        balloonContent: point.label
      }, {
        balloonContent: point.label,
        iconImageSize: [30, 26],
        iconImageOffset: [-15, -30],
        iconLayout: "default#imageWithContent",
        iconImageHref: require('~/assets/img/svg/common/pin-black.svg')
      })
    },
  }
}
